import { useCatalogData } from "../components/CatalogDataContext";
import { ProviderTile } from "../components/ui/ProviderTile";
import { StatusDot } from "../components/ui/StatusDot";

export function ProvidersPage() {
  const { providers, models } = useCatalogData();
  const sorted = [...providers].sort((a, b) => a.name.localeCompare(b.name));
  const count = (id: string) => models.filter((m) => m.providerId === id).length;

  return (
    <div>
      <p className="eyebrow">01 / PROVIDERS</p>
      <div className="page-header-row">
        <div>
          <h1 className="tl-title" style={{ fontSize: "clamp(1.65rem, 3vw, 2.4rem)" }}>
            Platforms
            <span className="ctx"> &amp; hosts</span>
          </h1>
          <p className="page-sub" style={{ marginBottom: 0, marginTop: "0.55rem" }}>
            API platforms and hosts for generative image and video models.
          </p>
        </div>
        <StatusDot kind="synced" label={`${sorted.length} LISTED`} />
      </div>
      <div className="grid-cards">
        {sorted.map((p) => (
          <ProviderTile key={p.id} provider={p} modelCount={count(p.id)} />
        ))}
      </div>
    </div>
  );
}
